import {v4 as $etkkV$v4} from "uuid";



const $3ce1fba1d1a9d2b6$export$7d576a40358207c0 = [
    "cvv",
    "expirationDate",
    "cardNumber"
];
var $3ce1fba1d1a9d2b6$export$bdb47a4f704771fb;
(function(GlobalPostMessageEventKind) {
    GlobalPostMessageEventKind["PAYMENT_CARD_FETCH_ERROR"] = "PAYMENT_CARD_FETCH_ERROR";
    GlobalPostMessageEventKind["PAYMENT_CARD_FETCH_SUCCESS"] = "PAYMENT_CARD_FETCH_SUCCESS";
    // Input/configuration error kind
    GlobalPostMessageEventKind["CARD_VIEWER_INPUT_ERROR"] = "CARD_VIEWER_INPUT_ERROR";
    GlobalPostMessageEventKind["INVALID_CREDENTIAL_ERROR"] = "INVALID_CREDENTIAL_ERROR";
    GlobalPostMessageEventKind["GENERIC_ERROR"] = "GENERIC_ERROR";
    GlobalPostMessageEventKind["TOGGLE_CARD_NUMBER_MASK"] = "TOGGLE_CARD_NUMBER_MASK";
    GlobalPostMessageEventKind["COPY_TO_CLIPBOARD_ERROR"] = "COPY_TO_CLIPBOARD_ERROR";
    GlobalPostMessageEventKind["COPY_TO_CLIPBOARD_SUCCESS"] = "COPY_TO_CLIPBOARD_SUCCESS";
    GlobalPostMessageEventKind["CARD_VIEWER_READY"] = "CARD_VIEWER_READY";
})($3ce1fba1d1a9d2b6$export$bdb47a4f704771fb || ($3ce1fba1d1a9d2b6$export$bdb47a4f704771fb = {}));


/* eslint-disable max-lines */ const $e3a89bedd7e30a46$export$1ec34c2c9b231c0f = [
    "pin",
    "cardNumber",
    "expirationMonth",
    "expirationYear",
    "expirationDate",
    "securityCode"
];
const $e3a89bedd7e30a46$export$2db53370b14e73a1 = [
    "visa",
    "mastercard",
    "amex",
    "discover"
];
var $e3a89bedd7e30a46$export$5278e3e6401288b4;
(function(SecureInputsGlobalPostMessageEventKind) {
    SecureInputsGlobalPostMessageEventKind["GENERIC_ERROR"] = "GENERIC_ERROR";
    SecureInputsGlobalPostMessageEventKind["INVALID_CREDENTIAL_ERROR"] = "INVALID_CREDENTIAL_ERROR";
    SecureInputsGlobalPostMessageEventKind["USER_INPUT_ERROR"] = "USER_INPUT_ERROR";
    SecureInputsGlobalPostMessageEventKind["REQUEST_ERROR"] = "REQUEST_ERROR";
    SecureInputsGlobalPostMessageEventKind["ON_INPUT"] = "ON_INPUT";
    SecureInputsGlobalPostMessageEventKind["ON_SUBMIT"] = "ON_SUBMIT";
    SecureInputsGlobalPostMessageEventKind["CHANGE_CARD_PIN"] = "CHANGE_CARD_PIN";
    SecureInputsGlobalPostMessageEventKind["TOKENIZE_CARD"] = "TOKENIZE_CARD";
    SecureInputsGlobalPostMessageEventKind["ON_CARD_INPUT"] = "ON_CARD_INPUT";
    SecureInputsGlobalPostMessageEventKind["ON_PIN_CHANGE_SUCCESS"] = "ON_PIN_CHANGE_SUCCESS";
    SecureInputsGlobalPostMessageEventKind["ON_TOKENIZE_CARD_SUCCESS"] = "ON_TOKENIZE_CARD_SUCCESS";
    SecureInputsGlobalPostMessageEventKind["ON_STATE_CHANGE"] = "ON_STATE_CHANGE";
    SecureInputsGlobalPostMessageEventKind["ON_READY"] = "ON_READY";
})($e3a89bedd7e30a46$export$5278e3e6401288b4 || ($e3a89bedd7e30a46$export$5278e3e6401288b4 = {}));






var $8b7b35e8227fc365$export$c278f139ce6eedba;
(function(CheckoutPostMessageKind) {
    CheckoutPostMessageKind["TOKENIZE_SUCCCESS"] = "TOKENIZE_SUCCCESS";
    CheckoutPostMessageKind["TOKENIZE_ERROR"] = "TOKENIZE_ERROR";
    CheckoutPostMessageKind["CHECKOUT_READY"] = "CHECKOUT_READY";
})($8b7b35e8227fc365$export$c278f139ce6eedba || ($8b7b35e8227fc365$export$c278f139ce6eedba = {}));
class $8b7b35e8227fc365$export$4e94f40711c15818 extends Error {
    constructor(message, errors){
        super(message);
        this.name = "CheckoutConfigInputError";
        // eslint-disable-next-line fp/no-mutation, fp/no-this
        this.errors = errors;
    }
}
const $8b7b35e8227fc365$export$e65600b7ad68fd67 = [
    "Pay",
    "Submit"
];


const $c5067a0ee133bdaa$export$8acf5617026d4b16 = [
    "borderRadius",
    "backgroundColor",
    "color",
    "cursor",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "letterSpacing",
    "lineHeight",
    "userSelect",
    "border"
];
const $c5067a0ee133bdaa$export$93b12edf1b0f1762 = [
    ":focus",
    ":hover",
    ":invalid",
    ":valid"
];
const $c5067a0ee133bdaa$export$679b0194e2408a3e = [
    "live",
    "test"
];


/* eslint-disable @typescript-eslint/strict-boolean-expressions */ /* eslint-disable fp/no-mutation */ 
var $6f4873648a5ee68b$exports = {};
$6f4873648a5ee68b$exports = JSON.parse('{"name":"@highnoteplatform/card-viewer","version":"1.4.1","description":"Render a payment card in your UI.","source":"src/index.ts","access":"public","main":"lib/index.js","module":"lib/esm/module.js","types":"lib/types.d.ts","files":["lib","README.md"],"scripts":{"clean":"rimraf lib dist","prebuild":"npm run clean","build":"PARCEL_WORKER_BACKEND=process parcel build --detailed-report --no-scope-hoist --no-cache","prepublishOnly":"npm run build","test":"jest","test:watch":"jest --watch","prepack":"npm run build","predev":"npm run clean","dev":"parcel watch --port 3002 --hmr-port 2002 --no-cache --dist-dir=lib"},"author":"packages@highnote.com","license":"MIT","homepage":"https://highnote.com","devDependencies":{"@types/jest":"^28.1.7","@types/jsdom":"21.1.1","@types/node":"^18.16.2","eslint-plugin-jest":"27.2.1","jest":"^28.1.3","jest-environment-jsdom":"^29.5.0","jsdom":"^21.1.1","ts-jest":"^28.0.8"},"targets":{"main":{"optimize":true},"module":{"optimize":true}},"dependencies":{"@types/uuid":"^9.0.1","uuid":"^9.0.0"}}');


// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const $8b1e78386f8e989c$var$CARD_VIEWER_IFRAME_PORT = 3003;
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const $8b1e78386f8e989c$var$packageVersion = (0, $6f4873648a5ee68b$exports.version) ?? "";
const $8b1e78386f8e989c$export$f76cea9319723dd2 = "https://cdn.highnote.com";
const $8b1e78386f8e989c$var$iframePath = (apiEnvironment)=>{
    // eslint-disable-next-line fp/no-let
    let path = "";
    path = `card-viewer/${$8b1e78386f8e989c$var$packageVersion}/`;
    return apiEnvironment === "test" ? `${path}index_test.html` : `${path}index.html`;
};
const $8b1e78386f8e989c$export$1c3aefb711c3a4cc = ()=>(0, $etkkV$v4)();
const $8b1e78386f8e989c$export$f7872bdb68630f49 = (apiEnvironment)=>`${$8b1e78386f8e989c$export$f76cea9319723dd2}/${$8b1e78386f8e989c$var$iframePath(apiEnvironment)}`;


const $ccd1657298de1ff5$export$28ca0294113407cf = (config)=>{
    const frame = document.createElement("iframe");
    const frameSource = new URL("clientToken" in config ? `${(0, $8b1e78386f8e989c$export$f7872bdb68630f49)(config.environment)}?field=cardNumber&token=${config.clientToken}&environment=${config.environment}&paymentCardId=${config.paymentCardId}&styles=${encodeURIComponent(JSON.stringify(config.styles ?? {}))}&enableClipboard=${config.enableClipboard ? "true" : "false"}&maskedOnLoad=${config.maskedOnLoad ? "true" : "false"}` : `${(0, $8b1e78386f8e989c$export$f7872bdb68630f49)(config.environment)}?field=${config.field}&styles=${encodeURIComponent(JSON.stringify(config.styles ?? {}))}&enableClipboard=${config.enableClipboard ? "true" : "false"}`);
    // eslint-disable-next-line fp/no-mutation
    frameSource.hash = config.uuid;
    frame.setAttribute("src", frameSource.toString());
    frame.setAttribute("allow", "clipboard-write");
    frame.style.setProperty("border", "none");
    return frame;
};



/* eslint-disable max-statements */ 

const $cdccc4c3b1631eba$var$FALLBACK_ERROR_MESSAGE = "Something went wrong. Please try again or contact support.";
const $cdccc4c3b1631eba$export$221b191fcfaf22a = (uuid, onError, onCopyToClipboardSuccess, onReady)=>(event)=>{
        if (event.origin !== (0, $8b1e78386f8e989c$export$f76cea9319723dd2) || uuid !== event.data.uuid) return false;
        const { data: data } = event.data;
        switch(data.__typename){
            case (0, $3ce1fba1d1a9d2b6$export$bdb47a4f704771fb).INVALID_CREDENTIAL_ERROR:
                {
                    const error = {
                        name: "InvalidCredentialError",
                        context: data.context
                    };
                    onError(error);
                    break;
                }
            case (0, $3ce1fba1d1a9d2b6$export$bdb47a4f704771fb).CARD_VIEWER_INPUT_ERROR:
                {
                    const error = {
                        name: "CardViewerFieldsInputError",
                        message: data.message
                    };
                    onError(error);
                    break;
                }
            case (0, $3ce1fba1d1a9d2b6$export$bdb47a4f704771fb).PAYMENT_CARD_FETCH_ERROR:
                {
                    const error = {
                        name: "CardViewerRequestError",
                        context: data.context,
                        message: data.message
                    };
                    onError(error);
                    break;
                }
            case (0, $3ce1fba1d1a9d2b6$export$bdb47a4f704771fb).COPY_TO_CLIPBOARD_ERROR:
                {
                    const error = {
                        name: "CopyToClipboardError",
                        message: data.message,
                        field: data.field
                    };
                    onError(error);
                    break;
                }
            case (0, $3ce1fba1d1a9d2b6$export$bdb47a4f704771fb).COPY_TO_CLIPBOARD_SUCCESS:
                onCopyToClipboardSuccess?.({
                    field: data.field
                });
                break;
            case (0, $3ce1fba1d1a9d2b6$export$bdb47a4f704771fb).CARD_VIEWER_READY:
                onReady?.();
                break;
            default:
                onError({
                    message: $cdccc4c3b1631eba$var$FALLBACK_ERROR_MESSAGE
                });
        }
        return true;
    };


// eslint-disable-next-line @typescript-eslint/require-await
const $28557506d24c8ef6$var$unmount = async (fields)=>{
    Object.values(fields).forEach((field)=>{
        if (field) field.container.replaceChildren("");
    });
};
const $28557506d24c8ef6$export$1b4461fdcf0903a6 = async ({ clientToken: clientToken, paymentCardId: paymentCardId, elements: elements, onError: onError, onCopyToClipboardSuccess: onCopyToClipboardSuccess, environment: environment = "test", enableClipboard: enableClipboard = true, maskedOnLoad: maskedOnLoad = true, onReady: onReady })=>{
    const uuid = (0, $8b1e78386f8e989c$export$1c3aefb711c3a4cc)();
    const fields = (0, $3ce1fba1d1a9d2b6$export$7d576a40358207c0).reduce((accum, field)=>{
        const container = document.querySelector(elements[field].selector) ?? document.body;
        const frame = field === "cardNumber" ? (0, $ccd1657298de1ff5$export$28ca0294113407cf)({
            clientToken: clientToken,
            paymentCardId: paymentCardId,
            styles: elements[field].styles,
            environment: environment,
            enableClipboard: enableClipboard,
            uuid: uuid,
            maskedOnLoad: maskedOnLoad
        }) : (0, $ccd1657298de1ff5$export$28ca0294113407cf)({
            field: field,
            styles: elements[field].styles,
            enableClipboard: enableClipboard,
            uuid: uuid,
            environment: environment
        });
        container.append(frame);
        return {
            ...accum,
            [field]: {
                container: container,
                frame: frame
            }
        };
    }, {
        cardNumber: undefined,
        cvv: undefined,
        expirationDate: undefined
    });
    window.removeEventListener("message", (0, $cdccc4c3b1631eba$export$221b191fcfaf22a)(uuid, onError, onCopyToClipboardSuccess, onReady));
    window.addEventListener("message", (0, $cdccc4c3b1631eba$export$221b191fcfaf22a)(uuid, onError, onCopyToClipboardSuccess, onReady));
    return {
        toggleCardNumberMask: ()=>{
            const targetWindow = fields.cardNumber?.frame.contentWindow;
            if (targetWindow === null || targetWindow === undefined) return {
                name: "CardViewerToggleMaskError",
                message: "Unable to toggle card number mask."
            };
            targetWindow.postMessage({
                __typename: (0, $3ce1fba1d1a9d2b6$export$bdb47a4f704771fb).TOGGLE_CARD_NUMBER_MASK
            }, (0, $8b1e78386f8e989c$export$f76cea9319723dd2));
            return undefined;
        },
        unmount: async ()=>{
            await $28557506d24c8ef6$var$unmount(fields);
        }
    };
};


export {$28557506d24c8ef6$export$1b4461fdcf0903a6 as renderFields};
//# sourceMappingURL=module.js.map
